
import { usePermission } from "../../context/PermissionContext";
import { Navigate } from "react-router-dom";

export default function PermissionProtectedRoute({ moduleName, action, children }) {
    const { canView, canViewAll, canAdd, canEdit, canDelete, canFullAccess, loading } = usePermission();

    if (loading) return null;

    const actionMap = {
        viewOnly: canView,
        viewAll: canViewAll,
        add: canAdd,
        edit: canEdit,
        delete: canDelete,
        full: canFullAccess
    };

    const check = actionMap[action];

    if (!check) {
        console.error(`❌ Unknown permission action: ${action}`);
        return <Navigate to="/no-access" replace />;
    }

    let allowed = false;

    if (Array.isArray(moduleName)) {
        allowed = moduleName.some(name => check(name));
    } else {
        allowed = check(moduleName);
    }
    // const allowed = check(moduleName);

    return allowed ? children : <Navigate to="/no-access" replace />;
}
